@for (order of displayableOrders | keyvalue; track order) {
  <div class="order">
    <h4 class="border-line">
      <span>
        {{ order.value[0].order_details.code.substr(4) }} | {{ order.value[0].order_details.table.table_type }} {{ order.value[0].order_details.table.name }} | {{ order.value[0].order_details.created_at | date:'shortTime' }}
      </span>
      @if (showPaid(order.value[0])) {
        <span class="green">
          | {{ 'ORDER.PAID' | translate  }}
        </span>
      }
      @if (showConfirmed(order.value[0])) {
        <span class="green">
          | {{ 'ORDER.CONFIRMED' | translate  }}
        </span>
      }
    </h4>

    @for (order of order.value; track order) {
      @if (isParent) {
        <h5>{{ order.section }}:</h5>
      }

      @for (line of order.lines; track line.id) {
        <app-cart-line-item [line]="line" [readOnly]="true"></app-cart-line-item>
      }
    }
  </div>
}
